
/** Decorative artwork uses only the actual theme name; unknown themes get the record motif. */
export function SceneThemeArtwork({ name, themeId, hero = false }: { name: string; themeId?: string; hero?: boolean }) {
  const key = `${themeId || ''} ${name}`.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase();
  const kind = /rock|metal/.test(key) ? 'rock' : /cinema|film|serie/.test(key) ? 'film' : /franc|chanson/.test(key) ? 'fr' : 'pop';
  return <div className={`scene-art scene-art-${kind}${hero ? ' scene-art-hero' : ''}`} aria-hidden="true"><strong>{name}</strong><i /></div>;
}
export default SceneThemeArtwork;
